<template>
  <div :class="['container flex flex-col pt-0.5 gap-0.5', { open }]">
    <menu-item
      v-for="(item, index) in items"
      :key="index + item.key"
      :items="item.children"
      :label="item.title ? computeTitle(item.title) : $t(`menu.${item.key}`)"
      :icon="item.icon"
      :depth="depth + 1"
      :href="item.href ? stripURLTrailingSlash(item.href) : ''"
      :tag="item.tag"
      :appearance="item.appearance"
      :open="isChildOpen[index]"
      @toggled="value => onChildToggled(index, value)"
    />
  </div>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue';
import { useRoute } from 'vue-router';
import { isPathMatching, SidebarNode } from '@bifrost-dev-docs-mfe/common/types/sidebar';
import { stripURLTrailingSlash } from '@/utils/url';
import MenuItem from './MenuItem.vue';

const props = defineProps({
  open: { type: Boolean, required: true },
  depth: { type: Number, default: 0 },
  items: { type: Array as PropType<SidebarNode[]>, required: true },
});

const route = useRoute();

const isChildOpen = ref(props.items.map(item => isPathMatching(item, route.path)));
const onChildToggled = (index: number, value: boolean) => {
  isChildOpen.value[index] = value;
};

function computeTitle(title: string | number): string {
  return typeof title === 'string' ? title : title.toString();
}
</script>

<style scoped lang="scss">
.container {
  &:not(.open) {
    height: 0;
    transition: height 1s ease-out;
    transform: scaleY(0);
  }
  &.open {
    transform-origin: top;
    transform: scaleY(1);
    transition: height 0.4s ease;
  }
  a {
    &:hover {
      text-decoration: var(--dp-left-side-bar-anchor-hover-text-decoration);
    }
  }
}
</style>
